/**
 * Is this tab the installed app rather than a browser tab?
 *
 * Two checks because the platforms disagree. Chrome and the rest honour the
 * `display-mode` media query, which reflects the manifest's `display:
 * "standalone"`. iOS Safari does not implement it for home-screen apps and
 * exposes the non-standard `navigator.standalone` instead — so the media query
 * alone silently reports every installed iPhone user as a browser visitor,
 * which is the majority of installs.
 */
export function isStandalone(): boolean {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    ('standalone' in navigator &&
      (navigator as unknown as { standalone: boolean }).standalone === true)
  )
}
